import { fetchFromRTM } from './index';
import * as constants from './constants';
import './typedef';

class AnnotationResolver {
  constructor(connection) {
    this.connection = connection;
  }
  /**
   * Fetch a list of annotations for an element
   *   [RTM Docs](https://unsightly-rock.cloudvent.net/messages/author-annotation-list/)
   * @param {Object} payload
   * @param {string} payload.rootElementId
   * @param {string} payload.elementId
   * @param {string} payload.elementType
   * @param {string} payload.motivation
   * @returns {Promise.<[ProjectDTO]>}
   */
  authorAnnotationList = async ({
    rootElementId,
    elementId,
    elementType,
    motivation,
  }) => {
    const message = {
      type: constants.RTM_AUTHOR_ANNOTATION_LIST,
      rootElementId,
      elementId,
      elementType,
      motivation,
    };

    const response = await fetchFromRTM(
      this.connection,
      message,
      constants.RTM_AUTHOR_ANNOTATION_LIST_OK,
      constants.RTM_AUTHOR_ANNOTATION_LIST_ERROR,
    );
    return response.coursewareAnnotation;
  };

  authorAnnotationGet = async ({
    annotationId,
    elementId,
    elementType,
  }) => {
    const message = {
      type: constants.RTM_AUTHOR_ANNOTATION_GET,
      annotationId,
      elementId,
      elementType,
    };
    const response = await fetchFromRTM(
      this.connection,
      message,
      constants.RTM_AUTHOR_ANNOTATION_GET_OK,
      constants.RTM_AUTHOR_ANNOTATION_GET_ERROR,
    );
    return response.coursewareAnnotation;
  };

  authorAnnotationCreate = async ({
    rootElementId,
    elementId,
    elementType,
    motivation,
    body,
    target,
  }) => {
    const message = {
      type: constants.RTM_AUTHOR_ANNOTATION_CREATE,
      rootElementId,
      elementId,
      elementType,
      motivation,
      body,
      target,
    };

    const response = await fetchFromRTM(
      this.connection,
      message,
      constants.RTM_AUTHOR_ANNOTATION_CREATE_OK,
      constants.RTM_AUTHOR_ANNOTATION_CREATE_ERROR,
    );
    return response.coursewareAnnotation;
  };

  authorAnnotationResolve = async ({
    rootElementId,
    coursewareAnnotationKeys,
    resolved,
  }) => {
    const message = {
      type: constants.RTM_AUTHOR_ANNOTATION_RESOLVE,
      rootElementId,
      coursewareAnnotationKeys,
      resolved,
    };

    const response = await fetchFromRTM(
      this.connection,
      message,
      constants.RTM_AUTHOR_ANNOTATION_RESOLVE_OK,
      constants.RTM_AUTHOR_ANNOTATION_RESOLVE_ERROR,
    );
    return response.coursewareAnnotation;
  };

  authorAnnotationUpdate = async ({
    annotationId,
    elementId,
    elementType,
    body,
    target,
  }) => {
    const message = {
      type: constants.RTM_AUTHOR_ANNOTATION_UPDATE,
      annotationId,
      elementId,
      elementType,
      body,
      target,
    };

    const response = await fetchFromRTM(
      this.connection,
      message,
      constants.RTM_AUTHOR_ANNOTATION_UPDATE_OK,
      constants.RTM_AUTHOR_ANNOTATION_UPDATE_ERROR,
    );
    return response.coursewareAnnotation;
  };

  authorAnnotationAggregate = async ({
    rootElementId,
    elementId,
    body,
    target,
  }) => {
    const message = {
      type: constants.RTM_AUTHOR_ANNOTATION_AGGREGATE,
      rootElementId,
      elementId,
      body,
      target,
    };

    const response = await fetchFromRTM(
      this.connection,
      message,
      constants.RTM_AUTHOR_ANNOTATION_AGGREGATE_OK,
      constants.RTM_AUTHOR_ANNOTATION_AGGREGATE_ERROR,
    );
    return response;
  }  

  authorAnnotationRead = async ({
    rootElementId,
    elementId,
    annotationIds,
    elementType,
    read,
  }) => {
    const message = {
      type: constants.RTM_AUTHOR_ANNOTATION_READ,
      rootElementId,
      elementId,
      annotationIds,
      elementType,
      read,
    };

    const response = await fetchFromRTM(
      this.connection,
      message,
      constants.RTM_AUTHOR_ANNOTATION_READ_OK,
      constants.RTM_AUTHOR_ANNOTATION_READ_ERROR,
    );
    return response;
  };

  authorAnnotationsRestore = async ({
    annotationIds,
    elementId,
    elementType,
  }) => {
    const message = {
      type: constants.RTM_AUTHOR_ANNOTATIONS_RESTORE,
      annotationIds,
      elementId,
      elementType,
    };

    const response = await fetchFromRTM(
      this.connection,
      message,
      constants.RTM_AUTHOR_ANNOTATIONS_RESTORE_OK,
      constants.RTM_AUTHOR_ANNOTATIONS_RESTORE_ERROR,
    );
    return response;
  };

  authorAnnotationsDelete = async ({
    annotationIds,
    elementId,
    elementType,
  }) => {
    const message = {
      type: constants.RTM_AUTHOR_ANNOTATIONS_DELETE,
      annotationIds,
      elementId,
      elementType,
    };

    const response = await fetchFromRTM(
      this.connection,
      message,
      constants.RTM_AUTHOR_ANNOTATIONS_DELETE_OK,
      constants.RTM_AUTHOR_ANNOTATIONS_DELETE_ERROR,
    );
    return response;
  };

  authorAnnotationDelete = async ({
    annotationId,
    elementId,
    elementType,
  }) => {
    const message = {
      type: constants.RTM_AUTHOR_ANNOTATION_DELETE,
      annotationId,
      elementId,
      elementType,
    };

    const response = await fetchFromRTM(
      this.connection,
      message,
      constants.RTM_AUTHOR_ANNOTATION_DELETE_OK,
      constants.RTM_AUTHOR_ANNOTATION_DELETE_ERROR,
    );
    return response;
  };
}

export default AnnotationResolver;
